<script setup lang="ts">
import { cn } from '@/lib/utils';
import { AccordionHeader, AccordionTrigger, type AccordionTriggerProps } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

import { MinusIcon, PlusIcon } from '@heroicons/vue/solid';

const props = defineProps<
  AccordionTriggerProps & { class?: HTMLAttributes['class']; disabled?: boolean; hideIcon?: boolean }
>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});
</script>

<template>
  <AccordionHeader class="flex">
    <AccordionTrigger
      v-bind="delegatedProps"
      :class="
        cn(
          'accordion-trigger group flex flex-1 items-center justify-between py-4 pt-0 text-left font-heading font-medium tracking-heading transition-all md:text-nowrap [&[data-state=open]>div]:rotate-180',
          !props.disabled && 'hover:underline',
          props.class
        )
      "
    >
      <slot />
      <slot v-if="!disabled && !hideIcon" name="icon">
        <div
          class="flex items-center justify-center rounded-full bg-gainsboro p-[7px] text-gunmetal transition-transform duration-200"
        >
          <MinusIcon class="size-4 shrink-0 group-data-[state=open]:block group-data-[state=closed]:hidden" />
          <PlusIcon class="size-4 shrink-0 group-data-[state=closed]:block group-data-[state=open]:hidden" />
        </div>
      </slot>
    </AccordionTrigger>
  </AccordionHeader>
</template>
